<div class="login-wrapper">
  <div class="login-container">
    <mat-card class="example-card">
      <mat-card-content>
        <mat-toolbar color="primary">Authentification</mat-toolbar>

        <div *ngIf="exist; else attente"></div>
        <ng-template #attente>
          <br />
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </ng-template>

        <form style="margin-top: 10px">
          <mat-form-field class="full-width">
            <input
              placeholder="Utilisateur"
              class="full-width"
              [(ngModel)]="nameUser"
              matInput
              name="login"
            />
          </mat-form-field>

          <mat-form-field class="full-width">
            <input
              (keydown.enter)="connection()"
              placeholder="Mot de passe"
              class="full-width"
              [(ngModel)]="passwordUser"
              matInput
              type="password"
              name="password"
            />
          </mat-form-field>
        </form>

        <mat-error [textContent]="errorMessage"></mat-error>

        <button
          class="full-width"
          [disabled]="disabledBtnConnection"
          (click)="connection()"
          mat-raised-button
          color="primary"
        >
          Connection
        </button>
      </mat-card-content>
    </mat-card>
  </div>
</div>
